import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocalizeDatePipe } from './localize-date.pipe';

@NgModule({
  declarations: [LocalizeDatePipe],
  imports: [CommonModule],
  exports: [LocalizeDatePipe],
})
export class LocalizeDateModule {}
